import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AnalyticsTracker from "@/components/AnalyticsTracker";

import Home from "@/pages/Home";
import AICounseling from "@/pages/AICounseling";
import ExpertCounseling from "@/pages/ExpertCounseling";
import Compare from "@/pages/Compare";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import Search from "@/pages/Search";
import StatePage from "@/pages/StatePage";
import CityPage from "@/pages/CityPage";
import CoursePage from "@/pages/CoursePage";
import CollegePage from "@/pages/CollegePage";
import Pricing from "@/pages/Pricing";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import { RealTalkPage } from "@/components/RealTalk";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";
import AdminColleges from "@/pages/admin/AdminColleges";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminWorkQueue from "@/pages/admin/AdminWorkQueue";
import AdminMidImport from "@/pages/admin/AdminMidImport";
import AdminMediaImport from "@/pages/admin/AdminMediaImport";
import AdminImportHistory from "@/pages/admin/AdminImportHistory";
import AdminDataHealth from "@/pages/admin/AdminDataHealth";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminCampusTruth from "@/pages/admin/AdminCampusTruth";
import { Navigate, useParams } from "react-router-dom";
import NotFound from "@/pages/NotFound";

// Legacy /colleges/:slug → 301 to /college/:slug (SPA does 200 replace; edge should 301).
function LegacyCollegeRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/college/${slug}`} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <AnalyticsTracker />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/ai-counseling" element={<AICounseling />} />
              <Route path="/expert-counseling" element={<ExpertCounseling />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/products/:slug" element={<ProductPage />} />
              <Route path="/colleges" element={<Search />} />
              <Route path="/colleges/:slug" element={<LegacyCollegeRedirect />} />
              <Route path="/search" element={<Search />} />
              <Route path="/state/:slug" element={<StatePage />} />
              <Route path="/city/:slug" element={<CityPage />} />
              <Route path="/course/:slug" element={<CoursePage />} />
              <Route path="/college/:slug" element={<CollegePage />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/real-talk" element={<RealTalkPage />} />
              <Route path="/campus-truth" element={<RealTalkPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/workqueue" element={<AdminWorkQueue />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/admin/leads/:id" element={<AdminLeadDetail />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
              <Route path="/admin/colleges" element={<AdminColleges />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              <Route path="/admin/mid-import" element={<AdminMidImport />} />
              <Route path="/admin/media-import" element={<AdminMediaImport />} />
              <Route path="/admin/import-history" element={<AdminImportHistory />} />
              <Route path="/admin/data-health" element={<AdminDataHealth />} />
              <Route path="/admin/campus-truth" element={<AdminCampusTruth />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
